export default __webpack_public_path__ + "static/cert-icon-16-b6fa4243845fa9cebefaaf70ef0cad3d.png";